/**
 * B3 (Task 15): dovezile unei activitati practice pot fi si PDF-uri, nu doar poze. Oriunde o dovada
 * se randeaza (dialogul de raspunsuri, coloana „Dovezi", pluginul IMAGE_UPLOAD, PhotoPicker), un PDF
 * pus intr-un `<img>` iese imagine sparta — de aici un singur test, comun, pe URL.
 *
 * Decide DOAR extensia caii: backendul (`/api/files/upload`, folderul LESSON_ANSWER_PHOTOS) refuza un
 * fisier a carui extensie nu se potriveste cu continutul, deci `.pdf` la capatul caii e un PDF, iar
 * orice extensie de poza (inclusiv `.jfif` / `.jpe`) ramane poza. Query-ul si hash-ul nu conteaza
 * (un SAS `?sig=…` sau `#page=2` nu schimba fisierul).
 */
function caleaDinUrl(url: string): string {
  return url.split(/[?#]/, 1)[0];
}

export function esteUrlPdf(url: string | null | undefined): boolean {
  if (!url) return false;
  return /\.pdf$/i.test(caleaDinUrl(url));
}

/** Ultimul segment al caii, decodat — numele afisat pe un tile PDF. */
export function numeFisierDinUrl(url: string | null | undefined, implicit = 'document.pdf'): string {
  if (!url) return implicit;
  const segment = caleaDinUrl(url).split('/').pop() ?? '';
  if (!segment) return implicit;
  try {
    return decodeURIComponent(segment) || implicit;
  } catch {
    return segment;
  }
}
